import { clearSessionParams, getSessionParams } from "../../features/session";
import type { NavigateFunction } from "react-router-dom";
import { logoutSilent } from "../../features/session";

export const handleRedirectBack = async (navigate: NavigateFunction, isFailure: boolean = false): Promise<void> => {
  const stored = getSessionParams();
  if (!stored?.returnUrl) {
    navigate("/error", {
      state: { errorCode: "400", errorMessageKey: "error.missingReturnUrl" },
    });
    return;
  }

  // Normalize the URL
  const finalUrl = /^https?:\/\//i.test(stored.returnUrl)
      ? stored.returnUrl
      : `https://${stored.returnUrl}`;

  // Clear our preview-space session params before leaving
  clearSessionParams();

  // Silent local/server cleanup, no internal routing
  await logoutSilent();

  // Same-origin? -> SPA navigate (no reload). Else -> top-level redirect.
  const target = new URL(finalUrl, window.location.href);

  if (isFailure) {
    target.searchParams.set("status", "rejected");
  }

  const sameOrigin = target.origin === window.location.origin;

  if (sameOrigin) {
    // If the Requester Portal is mounted within the same SPA/basename,
    // you can navigate directly without reloading.
    navigate(`${target.pathname}${target.search}${target.hash}`, { replace: true });
    return;
  }

  // Cross-origin: a reload is required to load the other site/app.
  const method = isFailure ? "GET" : (stored.returnMethod || "GET").toUpperCase();
  if (method === "POST") {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = target.toString();
    form.style.display = "none";
    document.body.appendChild(form);
    form.submit();
  } else {
    // Use replace so Back doesn't come back to preview space
    window.location.replace(target.toString());
  }
};
